import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import { i18n } from "../../translate/i18n";

const normalize = value => (value || "").trim().toLocaleLowerCase();

/**
 * `confirmationText` (opcional): ação destrutiva — o botão de confirmar só
 * habilita depois que o usuário digitar esse texto (sem diferenciar maiúsculas).
 */
const ConfirmationModal = ({ title, children, open, onClose, onConfirm, confirmationText }) => {
	const [typed, setTyped] = useState("");

	useEffect(() => {
		if (open) setTyped("");
	}, [open]);

	const blocked = !!confirmationText && normalize(typed) !== normalize(confirmationText);

	const confirm = () => {
		if (blocked) return;
		onClose(false);
		onConfirm();
	};

	return (
		<Dialog
			open={open}
			onClose={() => onClose(false)}
			aria-labelledby="confirm-dialog"
		>
			<DialogTitle id="confirm-dialog">{title}</DialogTitle>
			<DialogContent dividers>
				<Typography>{children}</Typography>
				{confirmationText && (
					<TextField
						autoFocus
						fullWidth
						margin="dense"
						variant="outlined"
						label={i18n.t("confirmationModal.typeToConfirm", { text: confirmationText })}
						value={typed}
						onChange={e => setTyped(e.target.value)}
						onKeyDown={e => {
							if (e.key !== "Enter") return;
							// Consome o Enter: confirmar fecha o modal e o MUI devolve o foco
							// ao botão que o abriu (ex.: excluir da linha); sem isto o navegador
							// entregava a ativação deste MESMO Enter a esse botão e o fluxo
							// recomeçava, abrindo um modal vazio (#4119).
							e.preventDefault();
							e.stopPropagation();
							confirm();
						}}
						inputProps={{ "data-testid": "confirmation-text-input" }}
						style={{ marginTop: 16 }}
					/>
				)}
			</DialogContent>
			<DialogActions>
				<Button
					variant="contained"
					onClick={() => onClose(false)}
					color="default"
				>
					{i18n.t("confirmationModal.buttons.cancel")}
				</Button>
				<Button
					variant="contained"
					onClick={confirm}
					disabled={blocked}
					color="secondary"
				>
					{i18n.t("confirmationModal.buttons.confirm")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ConfirmationModal;
